function TeamIcon({ isDarkMode }) {
	return (
		<svg
			className={`mx-auto h-12 w-12 ${
				isDarkMode ? 'text-gray-400' : 'text-gray-500'
			}`}
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
			/>
		</svg>
	)
}

export function NoTeamPlanView({ isDarkMode, redirecting, onUpgrade }) {
	return (
		<div className="py-8 text-center">
			<TeamIcon isDarkMode={isDarkMode} />
			<h3
				className={`mt-4 text-lg font-medium ${
					isDarkMode ? 'text-white' : 'text-gray-900'
				}`}
			>
				You're not on a Team plan
			</h3>
			<p
				className={`mt-2 text-sm ${
					isDarkMode ? 'text-gray-400' : 'text-gray-600'
				}`}
			>
				Upgrade to collaborate with your team and share subscription
				benefits.
			</p>
			<button
				onClick={onUpgrade}
				disabled={redirecting}
				className="mt-6 px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
			>
				{redirecting ? 'Redirecting...' : 'Upgrade to Team Plan'}
			</button>
		</div>
	)
}

export function CreateTeamView({ isDarkMode, onCreateClick }) {
	return (
		<div className="py-8 text-center">
			<TeamIcon isDarkMode={isDarkMode} />
			<h3
				className={`mt-4 text-lg font-medium ${
					isDarkMode ? 'text-white' : 'text-gray-900'
				}`}
			>
				Create Your Team
			</h3>
			<button
				onClick={onCreateClick}
				className="mt-6 px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
			>
				Create Team
			</button>
		</div>
	)
}
